import { render, staticRenderFns } from "./desktop-MT4.vue?vue&type=template&id=7c7b8b15&scoped=true&"
import script from "./desktop-MT4.vue?vue&type=script&lang=js&"
export * from "./desktop-MT4.vue?vue&type=script&lang=js&"
import style0 from "./desktop-MT4.vue?vue&type=style&index=0&id=7c7b8b15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b8b15",
  null
  
)

export default component.exports